import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../i18n/I18nProvider'

const QRTimer = () => {
   const { translations } = useTranslation()
    const cs = translations.common
    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = ""+(timeLeft % 60);
  return (
    <>
      <Typography
                    sx={{
                        fontWeight: 500,
                        fontSize: '14px',
                        color: '#444',
                        marginTop: '10px',
                    }}
                >
                    {cs.timeRemaining}: {minutes} : {seconds.padStart(2,'0')}
                </Typography> 
    </>
  )
}

export default QRTimer
